import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Col,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
} from "reactstrap";
import { useDispatch } from "react-redux";
import {
  addUserByRole,
  getRolesAdmin,
  downloadAllNationalsReport,
} from "../../slices/admin/thunk";
import { DASHBOARD_USER_ROLES } from "../../constants";
import Loading from "../../Components/Loading";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal.js";
import Swal from "sweetalert2";
import NationalTable from "../../Components/Tables/NationalTable/NationalTable.js";
import SearchBar from "../../Components/SearchBar/SearchBar.js";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole.js";
import HeadersRole from "../../Components/Headers/HeadersRole.js";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable.js";

import nationalIcon from "../../assets/images/iconsRoles/nationalIcon.svg";
import { useNavigate } from "react-router-dom";
const DashboardAdminNational = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [modalAddNational, setModalAddNational] = useState(false);

  const [national, setNational] = useState([]);
  const [totalNational, setTotalNationals] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const handleToggleModal = () => {
    setModalAddNational(!modalAddNational);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchRolesAdmin = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesAdmin({
          role: "nationals",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setNational(response.data);
      setTotalNationals(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setLoading(false);
      setSearchDone(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchRolesAdmin();
  }, [currentPage, debouncedSearchTerm, dispatch]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleCreateNational = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        addUserByRole({ role: DASHBOARD_USER_ROLES.NATIONAL, data: values })
      ).unwrap();
      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "National created successfully",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
        setModalAddNational(false);
        fetchRolesAdmin();
      } else {
        Swal.fire({
          title: "Error!",
          text:
            response.error.message || "An error occurred while adding National",
          icon: "error",
          confirmButtonText: "OK",
        });
        setModalAddNational(true);
        setLoadingCreate(false);
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "An error occurred while adding National",
        icon: "error",
        confirmButtonText: "OK",
      });
      setModalAddNational(true);
      setLoadingCreate(false);
      console.log(error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      {/* <Modal */}
      {modalAddNational && (
        <AddRoleModal
          open={modalAddNational}
          setOpen={setModalAddNational}
          roleToAdd={DASHBOARD_USER_ROLES.NATIONAL}
          onCreate={handleCreateNational}
          loading={loadingCreate}
        />
      )}
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole role="National" icon={nationalIcon} svg={true} />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name, email or company name"
                    shouldDisplaySearchBar={true}
                  />
                  <DropdownActionsTable
                    downloadMethod={downloadAllNationalsReport}
                  />
                </div>

                <ButtonAddRole open={handleToggleModal} roleToAdd="National" />
              </div>

              <Col xl={12}>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <NationalTable
                        data={national}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          currentPage,
                          totalPages,
                          pageSize,
                          totalItems: totalNational,
                          onChangePage: handleChangePage,
                        }}
                        searchDone={searchDone}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardAdminNational;
